import { injectable } from "inversify";
import IAddressFormService from "./IAddressFormService";
import AddressDTO from "features/shared/dtos/AddressDTO";
import AddressFindEnumDTO from "features/shared/enums/dynamic/AddressFindEnumDTO";
import { Nullable } from "features/shared/types/nullable";

@injectable()
export default class AddressFormService implements IAddressFormService {

  getOriginalAddressValues(address: AddressDTO): Record<string, Nullable<string>> {
    return {
      "DESC_TMZAKOSADAPUVOD": address.street!,
      "DESC_TMZAKPOPISNEPUVOD": address.evidenceNumber!,
      "DESC_TMZAKORIENTACNIPUVOD": address.houseNumber!,
      "DESC_TMZAKOBECPUVOD": address.city!,
      "DESC_TMZAKEVIDENCNIPUVOD": address.landRegistryNumber!,
      "DESC_TMZAKCASTOBCEPUV": address.cityPart!,
      "DESC_TMZAKPSCPUVOD": address.zipCode!,
      "DESC_TMZAKSTATPUVOD": address.countryCode!
    };
  }

  getNewAddressValues(address: AddressFindEnumDTO): Record<string, Nullable<string>> {
    return {
      "DESC_TMZAKOSADA": address.street!,
      "DESC_TMZAKPOPISNE": address.evidenceNumberType === "CisloPopisne" ? address.evidenceNumber! : null,
      "DESC_TMZAKEVIDENCNI": address.evidenceNumberType === "CisloEvidencni" ? address.evidenceNumber! : null,
      "DESC_TMZAKORIENTACNI": address.houseNumber!,
      "DESC_TMZAKOBEC": address.city!,
      "DESC_TMZAKCASTOBCE": address.city === address.cityPart ? null : address.cityPart!,
      "DESC_TMZAKPSC": address.zipCode!,
      "DESC_TMZAKSTAT": address.countryCode!
    };
  }


}